import { ReactNode } from 'react';

import { useWorkMode } from 'shared/utils/useWorkMode';

import { ErrorIndicator } from '../../../messages/ErrorIndicator';
import { useContentObjectProperty } from '../ContentObjectProvider';

type OrchestrationWrapperProps = {
  children: ReactNode;
};

export function OrchestrationWrapper(props: OrchestrationWrapperProps) {
  const { children } = props;
  const [errors] = useContentObjectProperty<Record<string, Array<string>>>('errors', 'widgetsFormData');
  const { isStudioEdit } = useWorkMode();

  if (isStudioEdit) {
    return <ErrorIndicator errors={errors}>{children}</ErrorIndicator>;
  }

  return <>{children}</>;
}
